import { useTranslation } from "react-i18next";
import {
  QuickFilterOption,
  QuickFilterToggleGroup,
} from "../../../common/components/functional/QuickFilterToggleGroup/QuickFilterToggleGroup";
import { Box } from "@mui/material";
import { SearchFilter } from "../../../common/components/functional/FilterSearchField/FilterSearchField";
import {
  getOrderQuickFilterPreset,
  OrderQuickFilterButton,
  OrderQuickFilterButtonType,
} from "./common";
import { useAppSelector } from "../../../app/hooks";

type Props = {
  selectedQuickFilter: OrderQuickFilterButtonType | "";
  onQuickFilterChange: (
    quickFilter: OrderQuickFilterButtonType | "",
    filters: SearchFilter[],
  ) => void;
};

export const OrderQuickFilterButtons = ({
  selectedQuickFilter,
  onQuickFilterChange,
}: Props) => {
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.user.user);

  const getQuickFilterPreset = (
    filterType: OrderQuickFilterButtonType,
  ): SearchFilter[] => getOrderQuickFilterPreset(filterType, user?.id, t);

  const quickFilterOptions: QuickFilterOption<OrderQuickFilterButtonType>[] = [
    {
      value: OrderQuickFilterButton.HANDLER_OWN_OPEN,
      label: t("order:handlerOwnOpen"),
    },
    {
      value: OrderQuickFilterButton.SELLER_OWN_OPEN,
      label: t("order:sellerOwnOpen"),
    },
    {
      value: OrderQuickFilterButton.TEAM_ACTION_NEEDED,
      label: t("order:teamNeedAction"),
    },
    {
      value: OrderQuickFilterButton.TEAM_OPEN_SHORT,
      label: t("order:teamOpenShort"),
    },
    {
      value: OrderQuickFilterButton.TEAM_OPEN_LONG,
      label: t("order:teamOpenLong"),
    },
  ];

  const handleChange = (newValue: OrderQuickFilterButtonType | "") => {
    if (newValue === "") {
      // Clear all filters - use getQuickFilterPreset with default to get empty filters
      const emptyFilters = getQuickFilterPreset(OrderQuickFilterButton.EMPTY);
      onQuickFilterChange("", emptyFilters);
    } else {
      const preset = getQuickFilterPreset(newValue);
      onQuickFilterChange(newValue, preset);
    }
  };

  return (
    <Box sx={{ marginBottom: "16px" }}>
      <QuickFilterToggleGroup<OrderQuickFilterButtonType>
        options={quickFilterOptions}
        value={selectedQuickFilter}
        onChange={handleChange}
        sx={{ width: "auto" }}
        hideCount
      />
    </Box>
  );
};
